import {errorMessage, successMessage} from './constant'

export const errorHandler = (message: string): string =>{
    // TODO (Saroj Dahal): Need to do uncomment this to make error messages uniform and cleaner in future
    // if (errorMessage.hasOwnProperty(message)) {
    //     return errorMessage[message]
    // }
    if (message) {
        return message
    }
    return errorMessage.STH_WENT_WRONG
}

export const successHandler = (message: string): string =>{
    if (successMessage.hasOwnProperty(message)) {
        return successMessage[message]
    }
    return successMessage.SUCCESS
}
